export default {
    '多元模版' : '多元模版',
    '合作模式' : '合作模式',
    '产品类型' : '产品类型',
    '品牌优势' : '品牌优势',
    '合作伙伴' : '合作伙伴',
    '即刻': '即刻',
    '开始创建属于您的品牌': '开始创建属于您的品牌',
    '拥有市场趋势': '拥有市场趋势',
    '高敏': '高敏',
    '锐': '锐',
    '度': '度',
    '最新': '最新',
    ' 熱門 ': ' 熱門 ',
    '五行': '五行',
    '星座': '星座',
    '合作模式' : '合作模式',
    '游戏API对接' : '游戏API对接',
    '八大游戏类型' : '八大游戏类型',
    '区块链、视讯、电子、棋牌、' : '区块链、视讯、电子、棋牌',
    '捕鱼、体育、电竞、彩票，' : '捕鱼、体育、电竞、彩票，',
    '50间以上国际级游戏平台，破万款游戏，' : '50间以上国际级游戏平台，破万款游戏，',
    '皆可藉由API对接整合至您的游戏平台上。': '皆可藉由API对接整合至您的游戏平台上。',
    '更多': '更多',
    '包网建置' : '包网建置',
    'BBIN提供近百款的模版，' : 'BBIN提供近百款的模版，',
    '快速稳定的数据线路': '快速稳定的数据线路',
    '以及强大的系统防护，': '以及强大的系统防护，',
    '专业的技术团队7x24随时为您服务，' : '专业的技术团队7x24随时为您服务，',
    '让您的站点能够站上高峰问鼎全球。': '让您的站点能够站上高峰问鼎全球。',
    'BBIN与多家国际游戏商合作，': 'BBIN与多家国际游戏商合作，',
    '丰富多元的游戏类型，拥上万款游戏，' : '丰富多元的游戏类型，拥上万款游戏，',
    '我们将是您最有力的合作伙伴。' : '我们将是您最有力的合作伙伴。',
    '包网建站': '包网建站',
    '最多元化的设计风格，最齐全的网站配色，' : '最多元化的设计风格，最齐全的网站配色，',
    '最多样化的版型配置，': '最多样化的版型配置，',
    'BBIN提供给您最完整具时尚、': 'BBIN提供给您最完整具时尚、',
    '热门的版型设计，您的需求我们能够一次满足。': '热门的版型设计，您的需求我们能够一次满足。',
    '区块链': '区块链',
    '视讯': '视讯',
    '电子': '电子',
    '棋牌': '棋牌',
    '捕鱼': '捕鱼',
    '体育': '体育',
    '电竞': '电竞',
    '彩票': '彩票',
    '世界顶尖机房': '世界顶尖机房',
    '7x24小时全面监控，核心节点极速网络，': '7x24小时全面监控，核心节点极速网络，',
    '多重防护，使您安心的好选择。': '多重防护，使您安心的好选择。',
    '智能数位管理后台': '智能数位管理后台',
    '整合最完整的玩家游戏数据、提供最全方位的金流动向分析，': '整合最完整的玩家游戏数据、提供最全方位的金流动向分析，',
    '揭露第一手最新游戏资讯，让您随时掌握，赢得先机。': '揭露第一手最新游戏资讯，让您随时掌握，赢得先机。',
    'BB区块链xSHA加密技术，多重加密无法串改，': 'BB区块链xSHA加密技术，多重加密无法串改，',
    '领先业界，缔造全球娱乐飨宴，尽在BBIN。': '领先业界，缔造全球娱乐飨宴，尽在BBIN。',
    '真人视讯': '真人视讯',
    '最据临场感真人荷官发牌，24小时线上即时开牌不间断，': '最据临场感真人荷官发牌，24小时线上即时开牌不间断，',
    '所有好玩新事物尽在BBIN。': '所有好玩新事物尽在BBIN。',
    '电子游戏': '电子游戏',
    'BBIN与30家以上国际级游戏商合作，': 'BBIN与30家以上国际级游戏商合作，',
    '破万款电子游戏，随君挑选。': '破万款电子游戏，随君挑选。',
    '棋牌游戏': '棋牌游戏',
    '从明清时期盛行至今，玩法多元丰富': '从明清时期盛行至今，玩法多元丰富',
    '斗地主、炸金花、牛牛，依然稳坐热搜排行榜，': '斗地主、炸金花、牛牛，依然稳坐热搜排行榜，',
    '深受华人地区玩家喜爱。': '深受华人地区玩家喜爱。',
    '捕鱼游戏': '捕鱼游戏',
    '现今电玩城里最火红的游戏类型，': '现今电玩城里最火红的游戏类型，',
    '透由剧情以炮弹系统攻击，捕获成功，': '透由剧情以炮弹系统攻击，捕获成功，',
    '鱼儿们将化成數不尽的金币，塞满屏幕，欢乐无比。': '鱼儿们将化成數不尽的金币，塞满屏幕，欢乐无比。',
    '体育赛事': '体育赛事',
    '提供上万场体育赛事投注，覆盖世界各地赛事，': '提供上万场体育赛事投注，覆盖世界各地赛事，',
    '让球、大小、半全场、波胆、单双、总入球、连串过关等多元竞猜，': '让球、大小、半全场、波胆、单双、总入球、连串过关等多元竞猜，',
    '年创百亿商机等您来+1。': '年创百亿商机等您来+1。',
    '电子竞技': '电子竞技',
    '提供时下最流行的电子竞技，拥有顶尖的技术支持与令人惊叹的视觉界面。': '提供时下最流行的电子竞技，拥有顶尖的技术支持与令人惊叹的视觉界面。',
    '让您的电竞玩家轻松上手，一目了然，轻松投注。': '让您的电竞玩家轻松上手，一目了然，轻松投注。',
    '彩票游戏': '彩票游戏',
    'BBIN多样独家创新玩法，彩种丰富多元；': 'BBIN多样独家创新玩法，彩种丰富多元；',
    '公平可验证的区块链技术，界面简单易懂，新世代玩法不容错过。': '公平可验证的区块链技术，界面简单易懂，新世代玩法不容错过。',
    'H5移动端APP': 'H5移动端APP',
    '随登即玩，一机在手，快乐随时拥有。': '随登即玩，一机在手，快乐随时拥有。',
    '专业的技术服务团队': '专业的技术服务团队',
    '全年365天，7x24小时，': '全年365天，7x24小时，',
    '专业技术团队随时为您服务。': '专业技术团队随时为您服务。',
    'BBIN自建顶尖高防数据中心，全球布局光纤缆线，数据中心拥全球国际稳定线路，完美防护，顶尖网络设施就在BBIN。': 'BBIN自建顶尖高防数据中心，全球布局光纤缆线，数据中心拥全球国际稳定线路，完美防护，顶尖网络设施就在BBIN。',
    '智能数位管理后台': '智能数位管理后台',
    'BBIN提供最完整的数位管理后台系统，让您洞悉玩家游戏动态，掌握资金来龙去脉，随时调整运营方针。': 'BBIN提供最完整的数位管理后台系统，让您洞悉玩家游戏动态，掌握资金来龙去脉，随时调整运营方针。',
    'H5移动端APP': 'H5移动端APP',
    '运用扫脸、指纹，手势密码快速登入，随点即玩，让您的娱乐永不断线。': '运用扫脸、指纹，手势密码快速登入，随点即玩，让您的娱乐永不断线。',
    '专业的技术服务团队': '专业的技术服务团队',
    'BBIN提供7x24小时专人线上咨询，以提升客户满意度为最高宗旨，而提供最全方位的技术服务是我们对您的坚持。': 'BBIN提供7x24小时专人线上咨询，以提升客户满意度为最高宗旨，而提供最全方位的技术服务是我们对您的坚持。',
    '全部' : '全部',
    '电子': '电子',
    '体育': '体育',
    '棋牌': '棋牌',
    '视讯': '视讯',
    '彩票': '彩票',
    '捕鱼': '捕鱼',
    '综合': '综合',
    '国际象棋和纸牌': '国际象棋和纸牌',
    '棋牌': '棋牌',
    '产品类型' : '产品类型',
    '合作伙伴': '合作伙伴',
    '时尚多元前台模版' : '时尚多元前台模版',
    'BBIN提供近百款的模版, 各式版型风格,' : 'BBIN提供近百款的模版, 各式版型风格,',
    // '众多色系搭配，展现出个人品牌风格或协助制作仿站.': '众多色系搭配，展现出个人品牌风格或协助制作仿站.',
    "黑金主题" : "黑金主题",
    "黑色主题5" : "黑色主题5",
    "黑色主题4" : "黑色主题4",
    "黑色主题3" : "黑色主题3",
    "黑色主题2" : "黑色主题2",
    "黑色主题" : "黑色主题",
    "过年主题2" : "过年主题2",
    "过年主题1" : "过年主题1",
    "蓝色主题" : "蓝色主题",
    "综合彩票": "综合彩票",
    "比格温" : "比格温",
    "新综合主题": "新综合主题",
    "新彩票" : "新彩票",
    "太阳城" : "太阳城",
    "古黑主题" : "古黑主题",
    "全民彩票主题" : "全民彩票主题",
    "体育Phlwin" : "体育Phlwin",
    "体育black" : "体育black",
    "maxim88主题" : "maxim88主题",
    "bet365主题" : "bet365主题",
    "23-深蓝" : "23-深蓝",
    "23- 深黑" : "23- 深黑",
    "细节" : "细节",
    "现场演示" : "现场演示",
    "所有款式" : "所有款式",
    "适用于综合信用及体育盘口. 里面包含了电子, 棋牌, 捕鱼, 哈希游戏, 体育, 真人视讯, 彩票等市面绝大多数主流游戏. 这是一款国际化产品, 支持多种语言, 而且里面设计了很多针对性的会员任务及活动." : "适用于综合信用及体育盘口. 里面包含了电子, 棋牌, 捕鱼, 哈希游戏, 体育, 真人视讯, 彩票等市面绝大多数主流游戏. 这是一款国际化产品, 支持多种语言, 而且里面设计了很多针对性的会员任务及活动."
    
}
